"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
var ark_request_1 = require("@tencent/ark-request");
var util_1 = require("../../util");
var base_channel_interface_1 = require("./base-channel.interface");
var base_1 = require("../../base");
var Request = /** @class */ (function () {
    function Request() {
    }
    /**
     * 发送请求，内部有重试逻辑
     *
     * @param {string} requestUrl
     * @param {Method} [method=Method.POST]
     * @param {string} [body]
     * @returns
     */
    Request.prototype.sendRequest = function (requestUrl, method, contentType, body) {
        var _a, _b, _c;
        if (method === void 0) { method = base_channel_interface_1.Method.POST; }
        if (contentType === void 0) { contentType = base_1.ContentType.FORM; }
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, , 6]);
                        data = void 0;
                        if (!(method === base_channel_interface_1.Method.GET)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ark_request_1.networkRequest.get(requestUrl)];
                    case 1:
                        data = _d.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, ark_request_1.networkRequest.post(requestUrl, body, { contentType: base_1.ContentTypeValueMap.get(contentType) })];
                    case 3:
                        data = _d.sent();
                        _d.label = 4;
                    case 4: return [2 /*return*/, new base_1.Result(undefined, data)];
                    case 5:
                        error_1 = _d.sent();
                        util_1.ConnectionLog.error("Request Failed, requestUrl:" + requestUrl + ", status:" + ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.request) === null || _a === void 0 ? void 0 : _a.status) + ", response:" + ((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.request) === null || _b === void 0 ? void 0 : _b.response) + ", responseText:" + ((_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.request) === null || _c === void 0 ? void 0 : _c.responseText) + ", error stack:" + (error_1 === null || error_1 === void 0 ? void 0 : error_1.stack) + ", error message:" + (error_1 === null || error_1 === void 0 ? void 0 : error_1.message));
                        return [2 /*return*/, new base_1.Result(error_1)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return Request;
}());
exports.Request = Request;
